//#region Imports
import { NgModule } from '@angular/core';
import { SharedModule } from './shared.module';
//#endregion

//#region Contract
import { CancellationComponent } from 'src/app/views/contract/cancellation/cancellation.component';
import { ContractConfirmationComponent } from 'src/app/views/contract/contract-confirmation/contract-confirmation.component';
import { ESignMsgAdvisorComponent } from 'src/app/views/contract/e-sign-msg-advisor/e-sign-msg-advisor.component';
import { ESignMsgEndorsementComponent } from 'src/app/views/contract/e-sign-msg-endorsement/e-sign-msg-endorsement.component';
import { ESignMsgComponent } from 'src/app/views/contract/e-sign-msg/e-sign-msg.component';
import { ElectronicSignatureAmendmentComponent } from 'src/app/views/contract/electronic-signature-amendment/electronic-signature-amendment.component';
import { ElectronicSignatureComponent } from 'src/app/views/contract/electronic-signature/electronic-signature.component';
import { LessorCertificateComponent } from 'src/app/views/contract/lessor-certificate/lessor-certificate.component';
import { PaymentComponent } from 'src/app/views/contract/payment/payment.component';
import { ServicesComponent } from 'src/app/views/contract/services/services.component';
import { ColocComponent } from 'src/app/views/contract/coloc/coloc.component';
import { CrossSellingComponent } from 'src/app/views/contract/cross-selling/cross-selling.component';
//#endregion

@NgModule({
  declarations: [
    ServicesComponent,
    LessorCertificateComponent,
    CancellationComponent,
    PaymentComponent,
    ElectronicSignatureComponent,
    ElectronicSignatureAmendmentComponent,
    ContractConfirmationComponent,
    ESignMsgComponent,
    ESignMsgAdvisorComponent,
    ESignMsgEndorsementComponent,
    ColocComponent,
    CrossSellingComponent
  ],

  imports: [SharedModule],

  exports: [
    ServicesComponent,
    CancellationComponent,
    PaymentComponent,
    ElectronicSignatureComponent,
    ElectronicSignatureAmendmentComponent,
    ContractConfirmationComponent,
    ESignMsgComponent,
    ESignMsgAdvisorComponent,
    ESignMsgEndorsementComponent,
    ColocComponent,
    CrossSellingComponent
  ]
})
export class ContractModule {}
